import { render, staticRenderFns } from "./PromotionSection.vue?vue&type=template&id=45ef1ebe&scoped=true"
import script from "./PromotionSection.vue?vue&type=script&lang=js"
export * from "./PromotionSection.vue?vue&type=script&lang=js"
import style0 from "./PromotionSection.vue?vue&type=style&index=0&id=45ef1ebe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ef1ebe",
  null
  
)

export default component.exports